import { z } from 'zod';

export const AppContextSchema = z.object({
  route: z.object({
    path: z.string(),
    params: z.record(z.string(), z.string()),
    query: z.record(z.string(), z.string()),
  }),
  dialogs: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      data: z.unknown().optional(),
    }),
  ),
  visibleEntities: z.array(
    z.object({
      kind: z.string(),
      id: z.union([z.string(), z.number()]),
      label: z.string().optional(),
    }),
  ),
  selection: z.array(
    z.object({
      kind: z.string(),
      id: z.union([z.string(), z.number()]),
    }),
  ),
  meta: z.record(z.string(), z.unknown()).default({}),
});

export type AppContext = z.infer<typeof AppContextSchema>;

export const EMPTY_APP_CONTEXT: AppContext = {
  route: { path: '/', params: {}, query: {} },
  dialogs: [],
  visibleEntities: [],
  selection: [],
  meta: {},
};
